import { Layout, Polar, RfidPrintIn } from '@/api';
import { Printer } from '@/types/store';
import { ProductItemForPrint, TypeOfStore } from '@/api/receive';
import { isEmpty } from './validation';

type CustomPrintBody = Omit<RfidPrintIn, 'layout' | 'serialNumberPrinter'>;

export const findPrint = (
  printers: Printer[],
  serialNumberPrinter: string
): Printer | undefined => {
  const printer = printers.find(
    ({ printerCode }) => printerCode === serialNumberPrinter
  );

  return printer;
};

export const handlePrintLayout = (
  currency: string,
  isRFID: boolean
): `${Layout}` => {
  if (isRFID) {
    return currency === 'USD' ? 'SRO NA' : 'SRO EMEA';
  }

  return currency === 'USD' ? 'SRO NA CREATE-TAG' : 'SRO EMEA CREATE-TAG';
};

export const handlePrintBody = (
  typeOfStore: TypeOfStore,
  product: ProductItemForPrint,
  additionalBody: RfidPrintIn
): RfidPrintIn => {
  const {
    retailPrice,
    retailDescription,
    // retailPercentage,
    outletPrice,
    outletDescription,
    outletPercentage,
    airportPrice,
    // airportDescription,
    // airportPercentage
  } = product;

  let printRequestBody: CustomPrintBody = {
    currency: product.currency,
    van: product.van,
    brandDescription: product.brandDescription,
    styleNameDescription: product.styleNameDescription,
    marketingThemeDescription: product.marketingThemeDescription,
    marketingStoryDescription: product.marketingStoryDescription,
    frameColor: product.frameColor,
    lensColor: product.lensColor,
    upcCode: product.upcCode!,
    //@ts-ignore
    polarCode: product.polarCode as Polar, // ??
  };

  switch (typeOfStore) {
    case TypeOfStore.OUTLET_EMEA:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice,
        second_price: outletPrice, // discount price
        second_price_type: 'OUTLET', // description
        discount_percent: !isEmpty(outletPercentage)
          ? `${outletDescription} ${outletPercentage}`
          : undefined, // percentage (add '%' symbol)
      };
      break;

    case TypeOfStore.AIRPORT_EMEA:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice,
        second_price: airportPrice, // airport_price
        second_price_type: 'TAX FREE',
      };
      break;

    case TypeOfStore.AIRPORT_UK:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice, // price
        second_price: airportPrice, // airport_price
        second_price_type: 'AIRPORT PRICE', // description
      };
      break;

    // In outlet stores, always display the full price ("retailPrice").
    // The "sale" flag is retrived by SAP only for US stores (retail, outlet or airport)
    // The "sale" flag means the item is discountable, the actual discount is applied at the checkout/cash register
    case TypeOfStore.OUTLET_US:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice, // retail price
        sale: retailDescription ? "SALE" : undefined,
      };
      break;

    case TypeOfStore.AIRPORT_US:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice, // retail price
        sale: retailDescription ? 'SALE' : undefined,
      };
      break;

    case TypeOfStore.RETAIL:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice, // retail price
        sale: retailDescription ? 'SALE' : undefined,
      };
      break;

    default:
      printRequestBody = {
        ...printRequestBody,
        price: retailPrice, // retail price
      };
      break;
  }

  return {
    ...printRequestBody,
    ...additionalBody,
  };
};
